// str_split_as
export const str_split_as = (str_s, split_s) => {
    return str_s.split(split_s)
}

// str_replace_s
export const str_replace_s = (str_s, from_s, to_s) => {
    return str_s.replace(from_s, to_s)
}

// str_replaceAt_s
export const str_replaceAt_s = (str, index, replacement) => {
    return str.substr(0, index) + replacement + str.substr(index + replacement.length);
}

// str_cleanEmail_s
export const str_cleanEmail_s = (email_s) => {
    let userEmailLowerSplit_as = email_s.toLowerCase().split('@')
    return `${userEmailLowerSplit_as[0].replace(/\./g, "")}@${userEmailLowerSplit_as[1]}`
}

//str_capitalizeFirstLetter_s
export const str_capitalizeFirstLetter_s = (s) => {
    return s && s[0].toUpperCase() + s.slice(1);
}


// str_parseString_fs
export const str_parseString_fs = (encodedStr) => {

    const parser = new DOMParser;
    const dom = parser.parseFromString('<!doctype html><body>' + encodedStr, 'text/html');

    return dom.body.textContent;
}